export default theme => ({
  root: {
    width: '100%',
    overflowY: 'hidden'
  }
})
